import React from "react";
import { Link } from "react-router-dom";
function PDOnlineCards() {
	return (
		<>
			<div className="row">
				<div className="col-lg-3 col-sm-6">
					<div className="card-box bg-blue">
						<div className="inner">
							<h3>Create Weekly Content</h3>
							<p>Create Weekly Content</p>
						</div>
						<div className="icon">
							<i className="fa fa-money" aria-hidden="true"></i>
						</div>
						<Link
							className="card-box-footer"
							to="/pdonlinecards/create-weekly-content"
						>
							Open
							<i className="fa fa-arrow-circle-right"></i>
						</Link>
					</div>
				</div>

				<div className="col-lg-3 col-sm-6">
					<div className="card-box bg-blue">
						<div className="inner">
							<h3>Get Weekly Content</h3>
							<p>Get Weekly Content</p>
						</div>
						<div className="icon">
							<i className="fa fa-money" aria-hidden="true"></i>
						</div>
						<Link
							className="card-box-footer"
							to="/pdonlinecards/get-weekly-content"
						>
							Open
							<i className="fa fa-arrow-circle-right"></i>
						</Link>
					</div>
				</div>
			</div>
		</>
	);
}

export default PDOnlineCards;
